/* global axios */
// [ByChat] Saúde/conexão das caixas no listing (Configurações > Caixas de Entrada).
// Busca UMA vez a lista de instâncias de conexão (provedores não-oficiais ByCall/
// Evolution/WAHA) e mantém um mapa inbox_id -> instância, compartilhado por todas as
// linhas do listing (em vez de um request por caixa). O status do WhatsApp Cloud
// oficial vem do próprio objeto do inbox (reauthorization_required), sem request extra.
import { reactive } from 'vue';

const state = reactive({ byInbox: {}, loaded: false, loading: false });

export function useInboxHealth() {
  return state;
}

// Status de conexão de UM inbox, derivado do mapa de instâncias (não-oficiais) ou do
// próprio inbox (WhatsApp Cloud oficial). Compartilhado pelo badge e pelas visões
// (compacta/kanban). Retorna null para canais sem conceito de conexão (site/e-mail).
// { tone: ok|warn|bad|muted, label, qr?, group: connected|connecting|disconnected|other }
export function statusFor(inbox) {
  if (!inbox) return null;
  const isApi = inbox.channel_type === 'Channel::Api';
  const isWhatsapp = inbox.channel_type === 'Channel::Whatsapp';

  if (isApi) {
    const inst = state.byInbox[inbox.id];
    const st = inst?.status;
    const name = inst?.instance_name;
    if (st === 'connected')
      return { tone: 'ok', label: 'Conectado', group: 'connected' };
    if (st === 'connecting')
      return { tone: 'warn', label: 'Conectando', group: 'connecting', qr: !!name };
    if (st === 'disconnected')
      return { tone: 'bad', label: 'Desconectado', group: 'disconnected', qr: !!name };
    if (!inst) return { tone: 'muted', label: 'Sem conexão', group: 'other' };
    return { tone: 'muted', label: st || '—', group: 'other', qr: !!name };
  }
  if (isWhatsapp) {
    return inbox.reauthorization_required
      ? { tone: 'bad', label: 'Reconectar', group: 'disconnected' }
      : { tone: 'ok', label: 'Conectada', group: 'connected' };
  }
  return null;
}

export async function loadInboxHealth(accountId, force = false) {
  if (!accountId) return;
  if (state.loading) return;
  if (state.loaded && !force) return;

  state.loading = true;
  try {
    const base = `/api/v1/accounts/${accountId}/kanban/connections`;
    const { data } = await axios.get(`${base}/instances`);
    const map = {};
    (data?.data || []).forEach(i => {
      if (i.inbox_id) map[i.inbox_id] = i;
    });
    state.byInbox = map;
    state.loaded = true;
  } catch (e) {
    // sem módulo de conexões / sem permissão — segue sem badge de não-oficial
    state.loaded = true;
  } finally {
    state.loading = false;
  }
}
